import React from 'react';
import {treeExpandCollapseContext} from '../treeExpandCollapseContext';

export const useTreeExpandCollapseContext = () => {
   return React.useContext(treeExpandCollapseContext);
};
